// @generated by protoc-gen-es v2.9.0 with parameter "target=dts+js,js_import_style=legacy_commonjs"
// @generated from file stailer_service_specification/customer_support/ivr/v1/ivr.proto (package stailer_service_specification.customer_support.ivr.v1, syntax proto3)
/* eslint-disable */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { fileDesc, messageDesc } = require("@bufbuild/protobuf/codegenv2");
const { file_description_support_v1_field_description } = require("../../../../description_support/v1/field_description_pb");

/**
 * Describes the file stailer_service_specification/customer_support/ivr/v1/ivr.proto.
 */
const file_stailer_service_specification_customer_support_ivr_v1_ivr = /*@__PURE__*/
  fileDesc("Cj9zdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi9jdXN0b21lcl9zdXBwb3J0L2l2ci92MS9pdnIucHJvdG8SNXN0YWlsZXJfc2VydmljZV9zcGVjaWZpY2F0aW9uLmN1c3RvbWVyX3N1cHBvcnQuaXZyLnYxIqgCCglGcmVzdGFJdnISZwoWaW5jb21pbmdfcGhvbmVfbnVtYmVycxgBIAMoCUJHkoIZMElWUuedgOS/oeeVquWPt++8iOODj+OCpOODleODs+eEoeOBl++8ieOBp+OBmeOAgqqCGQ9JVlLnnYDkv6Hnlarlj7cSsQEKLWhhc19zYW1lX3NpdGVfdXNlcl9pZF9hbmRfaXZyX2N1c3RvbWVyX251bWJlchgCIAEoCEJ6koIZR3VzZXIuc2l0ZVVzZXJJZCDjgaggSVZS5Lya5ZOh55Wq5Y+344GM5ZCM44GY5aC05ZCI44Gr5oyH5a6a44GX44G+44GZ44CCqoIZJ3NpdGVVc2VySWQg44GoIElWUuS8muWToeeVquWPt+OBjOWQjOS4gMiCGQFiBnByb3RvMw", [file_description_support_v1_field_description]);

/**
 * Describes the message stailer_service_specification.customer_support.ivr.v1.FrestaIvr.
 * Use `create(FrestaIvrSchema)` to create a new message.
 */
const FrestaIvrSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_customer_support_ivr_v1_ivr, 0);


exports.file_stailer_service_specification_customer_support_ivr_v1_ivr = file_stailer_service_specification_customer_support_ivr_v1_ivr;
exports.FrestaIvrSchema = FrestaIvrSchema;
